import React from 'react';
import { listOptions, ApplicationDropdown } from './';

export default function ApplicationsHeader({
  applications,
  contentItems,
  setContent,
}) {
  return (
    <div className="flex flex-col lg:flex-row justify-between lg:items-center capitalize">
      <p className="font-avenir-black tracking-wide text-navy-blue text-lg lg:mb-4">
        Applications
      </p>
      <ApplicationDropdown
        applications={applications}
        listOptions={listOptions(applications)}
        contentItems={contentItems}
        setContent={setContent}
      />
    </div>
  );
}
